<template>
  <b-modal has-modal-card trap-focus aria-role="dialog" aria-modal :active="guardActive" :on-cancel="cancel">
    <div class="modal-card">
      <section class="modal-card-body">
        <div class="columns has-background-white">
          <div class="column is-hidden-mobile">
            <picture>
              <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=320&height=350&gravity=smart&interlace=true&type=auto&quality=50&file=${this.$whitelabel.assetUrl}membership.jpg`" media="(min-width: 769px)" />
              <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=740&height=416&gravity=smart&interlace=true&type=auto&quality=50&file=${this.$whitelabel.assetUrl}membership.jpg`" media="(min-width: 501px)" />
              <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=281&gravity=smart&interlace=true&type=auto&quality=50&file=${this.$whitelabel.assetUrl}membership.jpg`" media="(max-width: 500px)" />
              <img importance="low" :src="`https://assets.urlaubsgutschein.kaufen/i/crop?width=320&height=350&gravity=smart&interlace=true&type=auto&quality=50&file=${this.$whitelabel.assetUrl}membership.jpg`" alt="Anmelden" loading="lazy" />
            </picture>
          </div>
          <div class="column">
            <h3 class="title is-size-4">{{ $t('membership.discount') }}</h3>
            <div v-show="step == 1">
              <p class="mb-4">{{ $t('membership.member1') }} {{ $whitelabel.short }} {{ $t('membership.member2') }}</p>
              <div class="columns">
                <div class="column">
                  <button @click="optNumber" class="button is-fullwidth is-secondary">{{ $t('general.no') }}</button>
                </div>
                <div class="column">
                  <button @click="nextStep" class="button is-fullwidth is-primary">{{ $t('general.yes') }}</button>
                </div>
              </div>
            </div>
            <div v-show="step == 2">
              <p class="mb-4">{{ $t('membership.member1') }} {{ $whitelabel.short }} {{ $t('membership.member2') }} {{ $t('membership.please-enter') }} {{ $whitelabel.short }} {{ $t('membership.membership') }}</p>

              <ValidationProvider name="Mitgliedsnummer" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('membership.member-number')">
                  <b-input class="is-block" type="text" placeholder="Ihre Mitgliedsnummer" v-model="numberInput" required expanded> </b-input>
                </b-field>
                <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
                <p v-show="isInvalid" class="help is-danger">{{ $t('membership.invalid') }}</p>
              </ValidationProvider>

              <div class="columns mt-1">
                <div class="column">
                  <button @click="verifyNumber" class="button is-fullwidth is-primary">{{ $t('general.next') }}</button>
                </div>
                <div class="column" v-if="isOptional">
                  <button @click="optNumber" class="button is-fullwidth is-text">{{ $t('general.skip') }}</button>
                </div>
              </div>

              <p class="mt-4">
                {{ $t('membership.nomember') }} {{ $whitelabel.short }} {{ $t('membership.member2') }}<br />
                <a href="https://www.adac.de/mitgliedschaft/" target="_blank" rel="noopener">{{ $t('membership.register') }}</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {GuardFactory} from '@/api/guard-provider'
export default {
  name: 'MembershipModal',
  props: {},
  computed: {
    ...mapGetters({
      guardActive: 'isGuarded',
    }),
  },
  data() {
    return {
      numberName: '',
      numberInput: '',
      isInvalid: false,
      isOptional: false,
      step: 2,
    }
  },
  mounted() {
    const gf = GuardFactory()
    this.numberName = gf.name()
    this.isOptional = gf.isOptional()
    if (!this.isOptional) {
      this.step = 2
    }
  },
  methods: {
    ...mapActions(['unlockGuard']),
    async verifyNumber() {
      if (this.numberInput) {
        const guard = GuardFactory()
        let res = await guard.verify(this.numberInput)
        if (res) {
          this.unlockGuard()
        } else {
          this.isInvalid = true
        }
      }
    },
    async optNumber() {
      const guard = GuardFactory()
      let res = await guard.verify(this.numberInput)
      if (res) {
        this.unlockGuard()
      } else {
        this.step = 2
      }
    },
    cancel() {
      this.unlockGuard()
    },
    nextStep() {
      this.step = 2
    },
  },
}
</script>

<style lang="scss">
.modal-card {
  max-width: calc(768px - 2rem);
  width: 100%;
  padding: 0 1rem;
}

.modal .animation-content {
  width: 100%; //fix for ie11
}
</style>
